import React, { useEffect, useState, useRef } from 'react';
import '../styles/pages/Making.scss';
import ArrowButton from '../components/utils/button/ArrowButton';
import FinalModal from '../components/utils/modal/FinalModal';
import { useParams } from 'react-router-dom';
import BranchModal from '../components/creating/modal/BranchModal';
import BackgroundModal from '../components/utils/modal/BackgroundModal';
import InfoModal from '../components/utils/modal/InfoModal';
import OXQuizLoading from '../components/utils/loading/QXQuizLoading';
import ConfirmModal from '../components/creating/modal/ConfirmModal';
import loginSessionCheck from '../components/utils/LoginSessionCheck';
import LandScapeModal from '../components/utils/modal/LandScapeModal';
import BackwardModal from '../components/creating/modal/BackwardModal';
import TextToSpeech from '../components/utils/TextToSpeech';
import {
    getStoryInfo,
    callChatGPTAPIforStory,
    callFalaiAPIforBackground,
    getFalaiBackgroundStatus,
    regenerateFalaiBackground,
} from '../api/StoryAPI';
import ModifyModal from '../components/utils/modal/ModifyModal';
import StoryImage from '../components/utils/StoryImage';
import ErrorModal from '../components/utils/modal/ErrorModal';
import { WordFilter } from '../utils/wordFilter/WordFilter';
import useAppTranslation from '../hooks/useAppTranslation';

const Making = () => {
    const { t } = useAppTranslation('pages/making');
    const USER_ID = localStorage.getItem('userID');

    const { selectedBookId } = useParams();

    // 마법콩 없음 에러모달
    const [errorInfo, setErrorInfo] = useState(null);

    useEffect(() => {
        const params = {
            story_id: selectedBookId,
        };
        callStoryInfoAPIFunc(params);
    }, [selectedBookId]);

    // 책 끝 페이지
    const pageEndCount = 9;

    // NOTE: state
    const [story, setStory] = useState([{}]); // api 호출 후 pre story 정보 저장 {page_id, page_content, background}
    const [storyTitle, setStoryTitle] = useState();
    const [branchInfo, setBranchInfo] = useState({}); // 분기점 정보 저장 {branchNum, title, options}
    const [pageCount, setPageCount] = useState(0); // 해당 스토리의 총 페이지 수

    const [showLoading, setShowLoading] = useState(false);

    const [loadingTitle, setLoadingTitle] = useState('');
    const [loadingTime, setLoadingTime] = useState(100);

    const [loadingFlag, setLoadingFlag] = useState('');
    const [generateEnd, setGenerateEnd] = useState(false);
    const [regenerateImage, setRegenerateImage] = useState([]);
    const [showInfoModal, setShowInfoModal] = useState(true); //경고 알림화면
    const [index, setIndex] = useState(0); // 데이터 인덱스
    const [showFinalModal, setShowFinalModal] = useState(false);

    // 2023.11.28 추가된 state-------------------------------------------
    const [showBranchModal, setShowBranchModal] = useState(false); //BranchModal 열고닫기
    const [showChoiceBtns, setShowChoiceBtns] = useState(false); //choiceBtn show,hidden 설정
    const [showImageModal, setShowImageModal] = useState(false); // 이미지모달 열고닫기
    const [showConfirmModal, setShowConfirmModal] = useState(false); //ConfirmModal 열고닫기
    const [showBackwardModal, setShowBackwardModal] = useState(false); //BackwardModal 열고닫기
    const [contentText, setcontentText] = useState([]);
    const [speechState, setSpeechState] = useState(false);

    // ---------------------2월 17일 테스트중...----------------------
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState('');

    // 2025-11-25 job id 저장용
    const [jobId, setJobId] = useState('');

    console.log('story', story);

    // 오디오 요소에 대한 참조 생성
    const audioRef = useRef(null);

    const controlLoading = (on, flag) => {
        if (on) {
            if (flag === 'story') setLoadingTime(100);
            else if (flag === 'reBg') setLoadingTime(30);
            setGenerateEnd(false);
            setShowLoading(true);
            setShowConfirmModal(false);
        } else {
            setGenerateEnd(true);
            setShowLoading(false);
            setShowConfirmModal(true);
            setSpeechState(false);
        }
    };

    const handleSpeechState = () => {
        if (speechState) {
            setSpeechState(false);
        } else {
            setSpeechState(true);
        }
    };

    //NOTE: 책 내용 조회 API 호출 함수
    const callStoryInfoAPIFunc = (param) => {
        const response = getStoryInfo(param);

        response.then((res) => {
            if (res.success) {
                console.log('@@ data =>', res.data);
                setStory(res.data.contents_json.story);
                setStoryTitle(res.data.title);
                let branchInfo = {
                    branchNum: res.data.contents_json.branchNum,
                    title: res.data.contents_json.branchTitle,
                    options: res.data.contents_json.branchOptions,
                };
                setBranchInfo(branchInfo);
                setPageCount(res.data.page_count);
            } else {
                console.log(res.error.errMsg);
            }
        });
    };

    const handleButtonClick = (direction) => {
        if (direction === 'right' && index === branchInfo.branchNum - 1) {
            setShowBranchModal(true);
            return;
        }

        if (direction === 'left' && index === branchInfo.branchNum) {
            setShowBackwardModal(true);
            return;
        }

        setIndex((prevIndex) => {
            console.log(`prevIndex: ${prevIndex}`);
            let newIndex = prevIndex + (direction === 'left' ? -1 : 1);
            if (newIndex < 0) {
                newIndex = pageCount - 1;
            }
            if (newIndex === pageEndCount + 1) {
                setShowFinalModal(true);
                newIndex = pageEndCount;
            }
            console.log(`newIndex: ${newIndex}`);
            return newIndex;
        });

        setIsEditing(false);
        console.log(`index: ${index}`);
    };

    const handleEditToggle = () => {
        if (!isEditing) {
            setEditValue(story[index]?.page_content || '');
        }
        setIsEditing(!isEditing);
    };

    const handleSave = () => {
        if (WordFilter(editValue)) {
            alert(t('alerts.unsafeWords'));
            return;
        }
        const newStory = [...story];
        newStory[index] = { ...newStory[index], page_content: editValue };
        setStory(newStory);
        setIsEditing(false);
    };

    const handleBackward = () => {
        setStory((prevStory) => {
            const newStory = prevStory.slice(0, branchInfo.branchNum);
            return newStory;
        });
        setIndex(index - 1);
        setShowBackwardModal(false);
        setShowChoiceBtns(false);
    };

    const handleCloseConfirmModal = () => {
        setShowConfirmModal(false);
        setSpeechState(true);
    };

    // 마침표에 따라서 split하기 (문장 단위로 줄바꿈하기)
    // const sentences = (story[index].page_content ?? '').split('\n');

    const sentences =
        story[index] && story[index].page_content
            ? story[index].page_content.split('\n')
            : [];

    const handleChoice = async (choice) => {
        console.log('사용자의 선택', choice);

        setShowBranchModal(false);
        setShowChoiceBtns(true);
        setLoadingTitle({
            story: t('loading.newStories', {
                count: pageCount - branchInfo.branchNum,
            }),
            bg: t('loading.newBackgrounds', {
                count: pageCount - branchInfo.branchNum,
            }),
        });

        setLoadingFlag('story');
        controlLoading(true, 'story');

        let generatedStory = await callAPIChatGPTforStory(choice);

        if (!generatedStory) {
            return;
        }

        try {
            if (typeof generatedStory === 'string') {
                generatedStory = JSON.parse(generatedStory);
            }

            if (Array.isArray(generatedStory)) {
                await callAPIFalaiforBackground(generatedStory);
            } else {
                console.error('generatedStory는 배열이 아닙니다.');
                alert(t('alerts.storyGenerationFailed'));
                setShowLoading(false);
                setShowBranchModal(true);
            }
        } catch (error) {
            console.error('JSON 파싱 오류:', error);
            alert(t('alerts.storyGenerationFailed'));
            setShowLoading(false);
            setShowBranchModal(true);
        }
    };

    const handleBackBranchModal = () => {
        setShowBranchModal(false);

        setStory((prevStory) => {
            const newStory = prevStory.slice(0, branchInfo.branchNum);
            return newStory;
        });
    };

    const handleReSelect = () => {
        setStory((prevStory) => {
            const newStory = prevStory.slice(0, branchInfo.branchNum);
            return newStory;
        });
        setIndex(branchInfo.branchNum - 1); // 분기점 페이지로 이동
        setShowBranchModal(true); // 선택 모달창 열기
        setShowChoiceBtns(false); // 다시 선택하기버튼, 이미지바꾸기 버튼 안보임
    };

    // 이미지 바꾸기 버튼 눌렀을떄
    const handleChangeBackground = async (generated) => {
        // 로딩 시작 세팅
        setLoadingTitle(t('loading.newBackground'));
        setLoadingFlag('title');
        controlLoading(true, 'reBg'); // 로딩 on

        try {
            // 🔹 현재 페이지 내용을 기반으로 간단 프롬프트 구성
            const current = story[index] || {};
            const basePrompt = current.page_content || '';

            const startRes = await regenerateFalaiBackground({
                user_id: USER_ID,
                story_id: selectedBookId,
                page_id: current.page_id,
                page_content: current.page_content,
                image_size: 'landscape_16_9',
                num_images: 1,
            });

            console.log('[FAL 재배경 startRes]', startRes);

            const code =
                startRes?.errCode ||
                startRes?.errorCode ||
                startRes?.error?.errCode ||
                startRes?.error?.errorCode ||
                null;

            const msg =
                startRes?.errMsg ||
                startRes?.errorMessage ||
                startRes?.error?.errMsg ||
                startRes?.error?.errorMessage ||
                startRes?.error ||
                t('errors.regenerateBackgroundFailed');

            // ❌ Fal.ai 호출 실패
            if (!startRes?.success) {
                controlLoading(false);
                setGenerateEnd(true);

                if (code === 'Magicbean_ERR_00') {
                    // 🫘 마법콩 부족
                    setErrorInfo({
                        code,
                        message: t('errors.magicbeanShortage'),
                    });
                } else {
                    setErrorInfo({
                        code,
                        message: msg,
                    });
                }
                return;
            }

            // ✅ 성공 → 배치 ID 얻고 상태 폴링
            const { batch_id } = startRes.data || {};
            if (!batch_id) {
                controlLoading(false);
                setGenerateEnd(true);
                setErrorInfo({
                    code: null,
                    message: t('errors.regenerateBackgroundFailed'),
                });
                return;
            }

            const finalData = await pollBackgroundStatus(batch_id, USER_ID);
            const urls = (finalData?.[0] ?? [])
                .map((o) => o?.url)
                .filter(Boolean);

            // 새로 생성된 이미지 목록 모달에 표시
            setRegenerateImage(urls);
            setGenerateEnd(true);
            setShowImageModal(true);
        } catch (e) {
            console.error('[handleChangeBackground error]', e);

            controlLoading(false);
            setGenerateEnd(true);

            const data = e?.response?.data;
            const code = data?.errorCode || data?.errCode || null;
            const msg =
                data?.errorMessage ||
                data?.errMsg ||
                t('errors.regenerateBackgroundProblem');

            if (code === 'Magicbean_ERR_00') {
                setErrorInfo({
                    code,
                    message: t('errors.magicbeanShortage'),
                });
            } else {
                setErrorInfo({
                    code,
                    message: msg,
                });
            }
        }
    };

    const handleBackgroundImageChange = (selectedImage) => {
        console.log('선택된 이미지:', selectedImage);

        setStory((prev) => {
            const copy = prev.map((p) => ({ ...p }));
            if (copy[index]) copy[index].background = selectedImage;
            return copy;
        });

        setShowImageModal(false);
    };
    // 2023.11.28 추가 | ImageModal -> Stories로 전달된 image
    // 이미지 선택하면 해당하는 이미지로 배경 이미지 변경

    console.log('setErrorInfo', errorInfo);

    const handleAlertConfirm = () => {
        console.log('click');
        setShowInfoModal(false);
    };

    const getAllStoryContent = async () => {
        let stories = '';
        for (const content of story) {
            stories = stories + ' ' + content.page_content;
        }
        return stories;
    };

    const callAPIChatGPTforStory = async (selectedBranch) => {
        const param = {
            user_id: USER_ID,
            story_id: selectedBookId,
            selectedBranch,
            stories: await getAllStoryContent(),
        };
        console.log('@@ param => ', param);

        const res = await callChatGPTAPIforStory(param);
        console.log('@@ callChatGPTAPIforStory res => ', res);

        // ✅ 공통 에러 정보 뽑기 (Story API는 errorCode / errorMessage 쓸 수 있음)
        const code =
            res?.errCode ||
            res?.errorCode ||
            res?.error?.errCode ||
            res?.error?.errorCode ||
            null;

        const msg =
            res?.errMsg ||
            res?.errorMessage ||
            res?.error?.errMsg ||
            res?.error?.errorMessage ||
            res?.error ||
            t('errors.storyCreationFailed');

        // 1) 실패 케이스 먼저 처리
        if (!res?.success) {
            // 🔴 마법콩 부족
            if (code === 'Magicbean_ERR_00') {
                setShowLoading(false);
                setShowBranchModal(false);
                setErrorInfo({
                    code,
                    message: t('errors.magicbeanShortage'),
                });
                return null; // 아래에서 배열로 처리하지 않도록
            }

            // 그 외 서버 에러들
            if (code === 'CHATGPT_ERR_00' || code === 'DATA_ERR_00') {
                console.log('@@ err => ', code);
            }
            console.log('@@ err => ', msg);

            setShowLoading(false);
            setShowBranchModal(true);
            return null;
        }

        // 2) 성공 케이스 → JSON 파싱
        let raw = res.data.story;
        setJobId(res.data.job_id);
        let jsonData = null;

        if (typeof raw === 'string') {
            const jsonPart = raw.match(/```json\s*([\s\S]*?)\s*```/);
            if (jsonPart && jsonPart[1]) {
                try {
                    jsonData = JSON.parse(jsonPart[1]);
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                    jsonData = null;
                }
            } else {
                // ```json``` 안 감싸고 그냥 문자열 JSON일 수도 있음
                try {
                    jsonData = JSON.parse(raw);
                } catch {
                    jsonData = raw;
                }
            }
        } else {
            jsonData = raw;
        }

        console.log('@@ callChatGPTAPI => ', jsonData);
        return jsonData;
    };

    // 이미지 생성 시작 API
    const callAPIFalaiforBackground = async (generatedStory) => {
        setLoadingFlag('bg');

        console.log('@@ generatedStory => ', generatedStory);
        const prompts = generatedStory.map((prompt) => ({
            background_prompt: prompt.background_prompt,
            character_prompt: prompt.character_prompt,
            image_size: 'landscape_16_9',
            num_images: 1,
        }));

        const startRes = await callFalaiAPIforBackground(
            selectedBookId,
            prompts,
            USER_ID,
            'storybook_story'
        );

        const code =
            startRes?.errCode ||
            startRes?.errorCode ||
            startRes?.error?.errCode ||
            startRes?.error?.errorCode ||
            null;

        const msg =
            startRes?.errMsg ||
            startRes?.errorMessage ||
            startRes?.error?.errMsg ||
            startRes?.error?.errorMessage ||
            startRes?.error ||
            t('errors.backgroundCreationFailed');

        if (!startRes?.success) {
            // 🫘 마법콩 부족
            if (code === 'Magicbean_ERR_00') {
                setShowLoading(false);
                setShowBranchModal(false);
                setErrorInfo({
                    code,
                    message: t('errors.magicbeanShortage'),
                });
                return;
            }

            console.log('배치 실패!', msg);
            setShowLoading(false);
            setShowBranchModal(true);
            return;
        }

        const { batch_id } = startRes.data;
        console.log('batch_id---->', batch_id);

        try {
            const finalImages = await pollBackgroundStatus(batch_id, USER_ID);

            const newStories = [...story];
            generatedStory.forEach((gs, i) => {
                const firstUrl = finalImages?.[i]?.[0]?.url || '';
                newStories.push({
                    background_prompt: gs.background_prompt,
                    character_prompt: gs.character_prompt,
                    page_id: gs.page_id,
                    page_content: gs.page_content,
                    background: firstUrl,
                });
            });
            console.log('newStories???', newStories);
            setStory(newStories);
            setIndex(branchInfo.branchNum);
            controlLoading(false);

            // 오디오 페이드인
            if (audioRef.current) {
                const audio = audioRef.current;
                audio.volume = 0;
                audioRef.current.play().catch(() => {});
                const targetVolume = 0.15,
                    duration = 2000,
                    steps = 20,
                    step = duration / steps;
                let n = 0;
                const id = setInterval(() => {
                    n++;
                    audio.volume = Math.min(
                        (targetVolume / steps) * n,
                        targetVolume
                    );
                    if (n >= steps) clearInterval(id);
                }, step);
            }
        } catch (e) {
            console.error('배경 폴링 실패:', e);
            setShowLoading(false);
            setShowBranchModal(true);
        }
    };

    console.log('story----->>>', story);

    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const pollBackgroundStatus = async (batchId, userId) => {
        while (true) {
            const res = await getFalaiBackgroundStatus({
                batch_id: batchId,
                user_id: userId,
            });

            // 디버그 한 줄 (매 턴 상태 확인)
            console.log(
                '[FAL] status:',
                res?.data?.status,
                'done?',
                res?.data?.all_completed,
                'imgs:',
                res?.data?.images?.length
            );

            if (!res?.success) throw new Error('배경 상태 조회 실패');

            const d = res.data ?? {};
            if (d.status === 'failed') throw new Error('배경 생성 실패');

            // ✅ 완료 시에만 images 반환 + 성공 로그 한 줄
            if (d.all_completed === true && Array.isArray(d.images)) {
                console.log('✅ FAL 완료! images 개수:', d.images.length);
                return d.images; // [ [ {url} ], [ {url} ], ... ]
            }

            // 아직 처리 중이면 잠깐 대기 후 반복
            await sleep(2000);
        }
    };

    const regenerateBackground = async (generatedPrompt) => {
        const prompts = [
            {
                background_prompt: generatedPrompt.background_prompt,
                character_prompt: generatedPrompt.character_prompt,
                image_size: 'landscape_16_9',
                num_images: 1,
            },
        ];

        let startRes;

        try {
            startRes = await callFalaiAPIforBackground(
                selectedBookId,
                prompts,
                USER_ID,
                'storybook_rebackground'
            );

            console.log('startRes', startRes);
        } catch (error) {
            console.error('[regenerateBackground Fal.ai error]', error);

            const errCode =
                error?.response?.data?.errCode ||
                error?.response?.data?.errorCode ||
                null;

            const errMsg =
                error?.response?.data?.errMsg ||
                error?.response?.data?.errorMessage ||
                t('errors.regenerateBackgroundFailed');

            // 🫘 마법콩 부족인 경우
            if (errCode === 'Magicbean_ERR_00') {
                controlLoading(false);
                setGenerateEnd(true);
                setErrorInfo({
                    code: errCode,
                    message: t('errors.magicbeanShortage'),
                });
                return;
            }

            // 그 외 404, 500 등도 한국어 메시지로 통일
            controlLoading(false);
            setGenerateEnd(true);
            setErrorInfo({
                code: errCode,
                message: errMsg,
            });
            return;
        }

        const code =
            startRes?.errCode ||
            startRes?.errorCode ||
            startRes?.error?.errCode ||
            startRes?.error?.errorCode ||
            null;

        const msg =
            startRes?.errMsg ||
            startRes?.errorMessage ||
            startRes?.error?.errMsg ||
            startRes?.error?.errorMessage ||
            startRes?.error ||
            t('errors.regenerateBackgroundFailed');

        if (!startRes?.success) {
            if (code === 'Magicbean_ERR_00') {
                controlLoading(false);
                setGenerateEnd(true);
                setErrorInfo({
                    code,
                    message: t('errors.magicbeanShortage'),
                });
                return;
            }

            console.log('재배경 시작 실패:', msg);
            controlLoading(false);
            setGenerateEnd(true);
            setErrorInfo({
                code,
                message: msg,
            });
            return;
        }

        try {
            const { batch_id } = startRes.data;
            const finalData = await pollBackgroundStatus(batch_id, USER_ID);
            const urls = (finalData?.[0] ?? [])
                .map((o) => o?.url)
                .filter(Boolean);

            setRegenerateImage(urls);
            setGenerateEnd(true);
            setShowImageModal(true);
        } catch (e) {
            console.error('[regenerateBackground poll error]', e);
            controlLoading(false);
            setGenerateEnd(true);
            setErrorInfo({
                code: null,
                message: t('errors.regenerateBackgroundFailed'),
            });
        }
    };

    useEffect(() => {
        const sentences =
            story[index] && story[index].page_content
                ? story[index].page_content.split('\n')
                : [];
        setcontentText(sentences.join(' '));
    }, [index, story]);

    return (
        <>
            {showInfoModal && (
                <InfoModal
                    onConfirm={handleAlertConfirm}
                    title={t('infoModal.warningTitle')}
                    tips={t('infoModal.blackScreenTips')}
                />
            )}
            <section className="stories-section">
                <audio
                    ref={audioRef}
                    src="/audio/twinkle-storybook.mp3"
                />

                {story[index] ? (
                    <StoryImage
                        src={story[index].background ?? ''}
                        alt={t('alts.backgroundImage')}
                    />
                ) : (
                    <div>{t('status.loadingBackground')}</div>
                )}

                {showChoiceBtns && (
                    <div className="choice-btns">
                        <div className="left-btn">
                            <div className="ballon">
                                {t('choice.reselectBubble')}
                            </div>
                            <div
                                className="btn go-choice-modal"
                                onClick={handleReSelect}
                            >
                                <figure>
                                    <img
                                        src="../images/utils/button/arrow-left.svg"
                                        alt={t('alts.reselect')}
                                    />
                                </figure>
                                <span>{t('actions.reselect')}</span>
                            </div>
                        </div>

                        <div className="right-btn">
                            <div className="ballon right">
                                {t('choice.changeImageBubble')}
                            </div>
                            <div
                                className="btn open-image-modal"
                                onClick={handleChangeBackground}
                            >
                                <figure>
                                    <img
                                        src="/images/utils/button/change-icon-button.svg"
                                        alt={t('alts.changeImage')}
                                    />
                                </figure>
                                <span>{t('actions.changeImage')}</span>
                            </div>
                        </div>
                    </div>
                )}
                {/* 2023.11.28 추가 | 처음으로 돌아가기, 이미지바꾸기 버튼 */}
                {!showFinalModal && !showBranchModal && (
                    <>
                        {index !== 0 && (
                            <ArrowButton
                                onClick={() => handleButtonClick('left')}
                                direction="left"
                                className="story-btn prev-btn"
                            />
                        )}
                        <ArrowButton
                            onClick={() => handleButtonClick('right')}
                            direction="right"
                            className="story-btn next-btn"
                        />
                    </>
                )}
                <div className="story-contents-container">
                    {showChoiceBtns && (
                        <div className="modify-btn-container">
                            <button
                                className="modify-btn"
                                onClick={handleEditToggle}
                            >
                                <figure>
                                    <img
                                        src={
                                            '/images/utils/button/cont-modi-btn.svg'
                                        }
                                        alt=""
                                    />
                                </figure>
                            </button>
                        </div>
                    )}
                    <div className="story-contents">
                        {isEditing ? (
                            <div className="edit-box">
                                <textarea
                                    value={editValue}
                                    onChange={(e) =>
                                        setEditValue(e.target.value)
                                    }
                                    className="edit-textarea"
                                />
                                <button
                                    onClick={handleSave}
                                    className="save-btn"
                                >
                                    {t('actions.save')}
                                </button>
                            </div>
                        ) : (
                            sentences.map((sentence, i) => (
                                <div
                                    key={i}
                                    className="origin-text"
                                >
                                    {sentence.trim()}
                                    <div className="text-stroke">
                                        {sentence.trim()}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
                <TextToSpeech
                    text={contentText}
                    speechState={speechState}
                    onChange={handleSpeechState}
                />

                <div className="numbering">{index + 1}</div>

                {showLoading && (
                    <OXQuizLoading
                        title={loadingTitle}
                        end={generateEnd}
                        flag={loadingFlag}
                        onEnd={() => setShowLoading(false)}
                        timeCount={loadingTime}
                    />
                )}
                {showConfirmModal && (
                    <ConfirmModal
                        title={storyTitle}
                        onClose={handleCloseConfirmModal}
                    />
                )}
                {showBackwardModal && (
                    <BackwardModal
                        onBack={handleBackward}
                        onClose={() => setShowBackwardModal(false)}
                    />
                )}

                {showBranchModal && (
                    <BranchModal
                        onChoice={handleChoice}
                        onClose={handleBackBranchModal}
                        choiceData={branchInfo}
                    />
                )}
                {showImageModal && (
                    <BackgroundModal
                        modalTitle={t('backgroundModal.title')}
                        propImg={regenerateImage}
                        originImg={story[index]?.background ?? ''}
                        onImageSelect={handleBackgroundImageChange}
                        onRegenerate={handleChangeBackground}
                        onClose={() => {
                            setShowImageModal(false);
                        }}
                    />
                )}
            </section>
            {showFinalModal && (
                <FinalModal
                    contentList={story}
                    story_id={selectedBookId}
                    branchNum={branchInfo.branchNum}
                    jobId={jobId}
                    onClose={() => setShowFinalModal(false)}
                />
            )}
            <LandScapeModal />
            {errorInfo && (
                <ErrorModal
                    error_message={errorInfo.message}
                    onClose={() => setErrorInfo(null)}
                />
            )}
        </>
    );
};

export default loginSessionCheck(Making);
